import React, { PureComponent } from 'react'
import { Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { BehaviorSubject, concat, of, Subscription } from 'rxjs'
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators'
import { IVRCallLogObservable } from '../../api/GovDonor/IVRCallLogObservable'
import { IVRCallLogRequest } from '../../api/GovDonor/Model/IVRCallLogRequest'
import { IVRLog } from '../../api/GovDonor/Model/IVRLog'
import FormatDate from '../../formatters/FormatDate'
import DatePicker from "react-datepicker"
import ActionButton from '../ActionButton'
import FormatPhone from '../../formatters/FormatPhone'

interface IVRLogProps {
  PersonID: number
}

interface IVRLogState {
  from: Date
  to: Date
  data: IVRLog[]
  loading: boolean
}


export default class IVRLogForm extends PureComponent<IVRLogProps, IVRLogState> {
  state = {loading: false, from: new Date(new Date().setDate(new Date().getDate() - 30)), to: new Date(), data: []}

  pageSubscription?: Subscription
  page$ = new BehaviorSubject<IVRCallLogRequest>({
    PersonId: this.props.PersonID,
    FromDate: this.state.from.toDateString(),
    ToDate: this.state.to.toDateString(),
  })

  componentDidMount() {
    this.pageSubscription = this.page$.pipe(
      distinctUntilChanged(),
      switchMap((params: IVRCallLogRequest) => concat(
        of({ loading: true }),
        IVRCallLogObservable(params).pipe(
          map((result: IVRLog[]) => ({ data: result, loading: false })))
        )
      )
    ).subscribe(
      (newState: { loading: boolean, data?: IVRLog[] }) => {
        if (newState.data) {
          this.setState({ loading: newState.loading, data: newState.data })
        } else {
          this.setState({ loading: newState.loading })
        }
      },
      (error: string) => {
        this.setState({ loading: false })
        toast.error(error)
      }
    )
  }

  componentWillUnmount() {
    this.pageSubscription && this.pageSubscription.unsubscribe()
    this.page$.unsubscribe()
  }

  applyFilter = () => this.page$.next({ ...this.page$.value, FromDate: this.state.from.toDateString(), ToDate: new Date((new Date()).setDate(this.state.to.getDate() + 1)).toDateString() })

  render() {
    return (<Container className="grid-container">
      <Form inline className="p-3">
        <Form.Group>
          <Form.Row>
            <Form.Label className="mr-1">From</Form.Label>
            <DatePicker className="form-control"
              required
              showMonthDropdown
              showYearDropdown
              maxDate={new Date()}
              dropdownMode="select"
              selected={ this.state.from }
              enableTabLoop={false}
              onChange={date => this.setState({ from: date as Date})}
            />
            <Form.Label className="ml-3 mr-1">To</Form.Label>
            <DatePicker className="form-control"
              required
              showMonthDropdown
              showYearDropdown
              minDate={ this.state.from }
              maxDate={ new Date() }
              dropdownMode="select"
              selected={ this.state.to }
              enableTabLoop={false}
              onChange={date => this.setState({ to: date as Date})}
            />
            <Col><ActionButton disabled={!this.state.from || !this.state.to} spin={this.state.loading} disableOnSpin onClick={ this.applyFilter }>Search</ActionButton></Col>
          </Form.Row>
        </Form.Group>
      </Form>
      <Table bordered responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>FromPhone</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {this.state.data && this.state.data.map((row: IVRLog) => <tr key={row.CallDate}>
            <td>{FormatDate(row.CallDate)}</td>
            <td>{row.PhoneNumber}</td>
            <td>{row.Message}</td>
          </tr> )}
          {!this.state.data?.length && <tr><td colSpan={3}>No Records Found</td></tr>}
        </tbody>
      </Table>
    </Container>)
  }
}
